import { ConfigurationValues } from '@cutr/constants/windows/windows';

import { unboxLabel } from '../Configurations';
import { optionFilterBySystem } from '../inputs/ConfigurationSelect';
import { ConfigurationSelect } from '../inputs/ConfigurationSelect';
import { ConfigurationComponent } from '.';

const SealantOuterColorConfig = () => (
  <ConfigurationSelect
    configurationKey="sealantOuterColor"
    dispatchAction="SET_SEALANT_OUTER_COLOR"
    optionsFilterFn={optionFilterBySystem}
  />
);

const config: ConfigurationComponent<'sealantOuterColor'> = {
  key: 'sealantOuterColor',
  input: <SealantOuterColorConfig />,
  display: (value: ConfigurationValues['sealantOuterColor']) => (
    <span>{unboxLabel(value.label)}</span>
  ),
};

export default config;
